import { render, staticRenderFns } from "./cusFnncsum.vue?vue&type=template&id=0b275e0a&scoped=true&"
import script from "./cusFnncsum.vue?vue&type=script&lang=js&"
export * from "./cusFnncsum.vue?vue&type=script&lang=js&"
import style0 from "./cusFnncsum.vue?vue&type=style&index=0&id=0b275e0a&prod&scoped=true&lang=css&"
import style1 from "./cusFnncsum.vue?vue&type=style&index=1&id=0b275e0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b275e0a",
  null
  
)

export default component.exports